import { useEffect } from "react";
import { SiGoogleclassroom } from "react-icons/si";
import { Link, useParams } from "react-router-dom";
import { useGetCourseById } from "../../api/useProducts/useCourses";
import { Sidebar } from "../../components";
import Loader from "../../components/Loader";
import VideoCard from "../../components/VideoCard";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
const CourseDetail = () => {
  const { courseId } = useParams();
  const { CourseData, CourseLoading, CourseRefetch } = useGetCourseById(
    Number(courseId)
  );

  useEffect(() => {
    CourseRefetch();
  }, [courseId]);
  const breadcrumbItems = [
    { title: "Courses", link: "courses" },
    { title: "Detail" },
  ];
  return (
    <Sidebar>
      {CourseLoading ? (
        <div className="flex h-[80vh] justify-center items-center">
          <Loader />
        </div>
      ) : (
        <div className="container mt-6 mx-auto px-4">
          <CustomBreadcrumb items={breadcrumbItems} />

          <p className="text-2xl capitalize font-medium my-2">
            {CourseData?.title}
          </p>
          {/* Course Title and Image */}
          <div className="mb-6">
            {CourseData?.image && (
              <div className="mb-4 md:mb-0">
                <img
                  src={CourseData?.image}
                  alt={CourseData?.title}
                  className="border rounded-2xl shadow-lg w-full max-h-96 object-cover"
                />
              </div>
            )}
            <br />
            <div className="flex border-b-2">
              <span className="border-b-[3.5px] border-darkCyan font-medium ms-4 pb-2 px-3 translate-y-[2px]">
                Overview
              </span>
            </div>

            <div className="mt-3">
              {CourseData?.isCustom && (
                <div className="flex gap-2 items-center mt-5">
                  <h3 className="font-medium">Link :</h3>
                  <Link
                    to={CourseData?.courseLink || ""}
                    target="_blank"
                    className="text-darkCyan text-sm underline"
                  >
                    {CourseData?.courseLink}
                  </Link>
                </div>
              )}
              <div className="mt-3">
                <h3 className="font-medium">Description</h3>
                <br />
                <p className="text-base">
                  {CourseData?.description?.trim() ? (
                    <div
                      className="whitespace-pre-line"
                      dangerouslySetInnerHTML={{
                        __html: CourseData.description,
                      }}
                    />
                  ) : (
                    "N/A"
                  )}
                </p>
              </div>
            </div>
          </div>

          {!CourseData?.isCustom && (
            <div>
              <h2 className="text-gray-800 font-medium mb-6">Classes</h2>
              {/* Course Classes */}
              {CourseData?.classes && CourseData?.classes?.length > 0 ? (
                <div className="mt-8">
                  <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 sm:grid-cols-3">
                    {CourseData?.classes?.map((classItem) => (
                      <div key={classItem?.id}>
                        <VideoCard
                          media={classItem?.media}
                          description={classItem?.description}
                          title={classItem?.title}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="flex flex-col text-[#D9D9D9] items-center">
                  <SiGoogleclassroom size={100} />
                  <p className="text-lg font-semibold">No Class right now!</p>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </Sidebar>
  );
};

export default CourseDetail;
